export default __webpack_public_path__ + "static/media/Resume-Goldstein.324adb6d.pdf";